import { Roles } from "../../mp-utils/generic-utils"

export const ROLES_MAP = {
  [Roles.Super_Administrator]: "admin",
  [Roles.District_Admin]: "author",
  [Roles.School_Admin]: "author",
  [Roles.Teacher]: "author",
  [Roles.Sales_Rep]: "author",
  [Roles.Instructor]: "author",
  [Roles.Course_Author]: "author",
  [Roles.Student]: "student"
}

export const CONFIG_SEQ_ORD = "config"

export const CONTENT_RESOURCE_SEPARATOR = "_"
